import * as React from 'react';

const IconArrowChevronLeftArrowLeft = ({ size = 24, color = '#313A44' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8843 6.20389C15.1998 5.86311 15.1998 5.33685 14.8843 4.99607L14.6143 4.70442C14.2624 4.32445 13.6616 4.32445 13.3098 4.70442L7.11387 11.3961C6.79833 11.7369 6.79833 12.2631 7.11387 12.6039L13.3099 19.2956C13.6617 19.6755 14.2625 19.6755 14.6144 19.2956L14.8844 19.0039C15.1999 18.6631 15.1999 18.1369 14.8844 17.7961L9.51765 12L14.8843 6.20389Z"
        fill={color}
      />
    </svg>
  );
};

export default React.memo(IconArrowChevronLeftArrowLeft);
